import { useAuthStore } from 'store/useAuthStore';
import EnterInfo from './EnterInfo';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'util/Constants';

const SignUpPage = () => {
    const navigate = useNavigate();
    const {
        userEmailAndId: { userId },
    } = useAuthStore();

    // If signup is successful, directly navigate to login
    if (userId) {
        navigate(ROUTES.SIGN_IN);
        return null;
    }

    return (
        <div className="lg:grid grid-cols-2 w-screen h-screen py-[24px] px-[18px]">
            <div className="relative hidden lg:block rounded-[15px] bg-my-green bg-opacity-40 overflow-hidden border border-my-gray">
                <img
                    alt={'SignUp Logo'}
                    src="/image/SignUp-Logo.png"
                    className="absolute top-1/2 right-[40%] transform translate-x-1/2 -translate-y-1/2 h-[95%] w-auto rounded-[15px] object-cover object-left"
                />
            </div>
            <EnterInfo />
        </div>
    );
};

export default SignUpPage;
